import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

(() => {
	const menuToggle = document.querySelector('.menu-toggle');
	const header = document.querySelector('#masthead');
	const menu = header.querySelector('.menu');

	if(menuToggle) {
		menuToggle.addEventListener('click', () => {
			if(document.body.classList.contains('toggled-menu')) {
				document.body.classList.remove('toggled-menu');
				enableBodyScroll(menu);
				header.style.paddingRight = '';
			} else {
				document.body.classList.add('toggled-menu');
				disableBodyScroll(menu, { reserveScrollBarGap: true });
				header.style.paddingRight = document.body.style.paddingRight;
			}
		});
	}
})();